document.addEventListener('DOMContentLoaded', () => {
  /* -----------------------------
     Load Recently Viewed Articles
  ----------------------------- */
  const container = document.getElementById('recently-viewed-articles');
  const template = document.getElementById('recent-article-template');
  const key = 'recently_viewed_articles';
  const expiry = 24 * 60 * 60 * 1000; // 24 hours
  const now = Date.now();

  let articles = JSON.parse(localStorage.getItem(key)) || [];
  articles = articles.filter(a => now - a.timestamp < expiry);

  if (!articles.length) {
    container.innerHTML = '<p>No recently read blogs found.</p>';
    return;
  }

  articles.forEach(article => {
    const clone = template.cloneNode(true);
    clone.id = '';
    clone.classList.remove('hidden');

    const link = clone.querySelector('a');
    const img = clone.querySelector('img');
    const cat = clone.querySelector('.blog-post-card__category');
    const title = clone.querySelector('.blog-post-card__title');
    const excerpt = clone.querySelector('.blog-post-card__excerpt');

    link.href = article.url;
    title.textContent = article.title;
    excerpt.textContent = article.excerpt || '';
    if (cat) cat.textContent = article.tag || '';

    if (article.image) {
      img.src = article.image;
      img.alt = article.title;
    } else {
      img.closest('.blog-post-card__image').remove();
    }

    container.appendChild(clone);
  });

  template.remove();

  /* -----------------------------
     Carousel + Progress + Buttons
  ----------------------------- */
  const wrappers = document.querySelectorAll('.recently-read-article-list-grid-wrapper');

  wrappers.forEach(wrapper => {
    const scrollAmount = wrapper.clientWidth + 30;
    const grid = wrapper.querySelector('.recently-read-article-list-blocks');
    const prevBtn = wrapper.querySelector('.carousel-prev');
    const nextBtn = wrapper.querySelector('.carousel-next');
    const progressBar = wrapper.querySelector('.recently-viewed-blogs-progress .progress-bar');

    if (!grid || !prevBtn || !nextBtn) return;

    const scrollByAmount = dir => grid.scrollBy({ left: dir * scrollAmount, behavior: 'smooth' });

    prevBtn.addEventListener('click', e => { e.preventDefault(); scrollByAmount(-1); });
    nextBtn.addEventListener('click', e => { e.preventDefault(); scrollByAmount(1); });

    const updateUI = () => {
      const { innerWidth } = window;
      const isDesktop = innerWidth > 768 && grid.classList.contains('desktop-view-carousel');
      const isMobile = innerWidth <= 768 && grid.classList.contains('mobile-view-carousel');
      const isCarousel = isDesktop || isMobile;
      const cards = grid.querySelectorAll('.article-list-block:not(.hidden)');
      const showButtons = (isDesktop && cards.length > 3) || (isMobile && cards.length > 1);

      if (!isCarousel || !showButtons) {
        prevBtn.classList.remove('show');
        nextBtn.classList.remove('show');
        if (progressBar) progressBar.style.width = '0%';
        return;
      }

      prevBtn.classList.add('show');
      nextBtn.classList.add('show');

      const { scrollLeft, scrollWidth, clientWidth } = grid;
      const atStart = scrollLeft <= 1;
      const atEnd = scrollLeft >= scrollWidth - clientWidth - 1;

      prevBtn.style.opacity = atStart ? '0.3' : '1';
      nextBtn.style.opacity = atEnd ? '0.3' : '1';
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;

      if (isMobile && progressBar) {
        const progress = (scrollLeft / (scrollWidth - clientWidth)) * 100;
        progressBar.style.width = `${progress}%`;
      }
    };

    setTimeout(updateUI, 300);
    grid.addEventListener('scroll', () => setTimeout(updateUI, 10));
    window.addEventListener('resize', () => setTimeout(updateUI, 200));
  });
});